import { EventGraphBase, EventGraphNode, EventGraphNodeRender, EventHandlerCmdEnd, EventHandlerGeneratePri, EventHandlerGrid, EventHandlerStart, UpdateType } from "pytha2";
import { EventHandlerGenGridPoint } from "../event-handler/EHGenGridPoint";


/**
 * 生成轴线网点
 */
export class EventGraphGenGridPoint extends EventGraphBase {

    /**
     * gengridpoint指令 用于注册事件图
     */
    static cmd = 'GENGRIDPOINT';

    putInLastCmd: boolean = false

    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerGenGridPoint);
        const node3 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node4 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node5 = new EventGraphNode(this, EventHandlerGrid);
        const node6 = new EventGraphNode(this, EventHandlerGeneratePri);

        this.addEdge(node1, node2);
        this.addEdge(node4, node3);
        this.addEdge(node5, node4);
        this.addEdge(node2, node6);
        this.addEdge(node6, node5);

        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;

        // https://event.graph.tncet.com/graphs/126
    }
}